import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialogLoading: false,
    dialogMSG: false,
    msgAlert: "",
    slides: []
  },
  mutations: {
    loadingModal(state, flag){
      state.dialogLoading = flag
    },
    loadSlides(state, data){
      state.slides = data
    },
    dialogMSG(state, params){
      state.msgAlert = params.msg
      state.dialogMSG = params.flag
    }
  },
  actions: {
    getSlidesAsinc(context, payload){
      context.commit('loadingModal', true)
      let url = process.env.VUE_APP_API_URL+"tutoriales_path"
      //
      axios
      .get(url)
      .then((res)=> {
        context.commit('loadingModal', false)
        context.commit('loadSlides', res.data)
      })
      .catch(error => {
        context.commit('loadingModal', false)
      })
    }
  },
})
